module.exports = __webpack_public_path__ + "img/list_icon4.dcc79f23.png";